import axios from "axios";
import Config from "../../config/config";

const getPedidoByNumber = (number) => {
  return axios({
    method: "get",
    url: `${Config.dev ? Config.api_dev : Config.api_prod}/api/v1/apps/pdv/pedidos/pedido/${number}`,
  });
};

export default getPedidoByNumber;
